import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { Flex } from 'components/shared/flex'
import { SelectItem } from 'components/shared/input'
import { TableCell } from 'components/shared/widget'
import { TransportationReport } from 'entities/transportation_report'
import { ReactNode, useMemo } from 'react'
import { Badge, ProgressBar } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { TransportationReportViewModel } from 'view_models/transportation_report_view_model'

export const transportationReportColumnInfoList = (form?: Form<Record<string, unknown>>, vendorSelectItems?: SelectItem[]): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'transportation_report_id', searchType: { name: 'id', type: 'multiple_text' } },
            {
                name: '業者',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'transportation_report_vendor_id',
                searchType: { name: 'vendor_id', type: 'multiple_select', selectItems: vendorSelectItems },
            },
            {
                name: '伝票番号',
                th: true,
                width: 150,
                form: form,
                orderAttr: 'transportation_report_number',
                searchType: { name: 'vendor_id', type: 'multiple_select', selectItems: vendorSelectItems },
            },
            {
                name: '集荷日',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'transportation_report_collection_date',
                searchType: { name: 'collection_date', type: 'date' },
            },
            {
                name: '受入日',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'transportation_report_delivery_date',
                searchType: { name: 'delivery_date', type: 'date' },
            },
            {
                name: '依頼書枚数',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'transportation_report_request_form_count',
                searchType: { name: 'request_form_count', type: 'number' },
            },

            {
                name: 'スピッツ数',
                th: true,
                width: 90,
                align: 'center',
                form: form,
                orderAttr: 'transportation_report_request_form_count',
                searchType: { name: 'request_form_count', type: 'number' },
            },
            {
                name: '検品回数',
                th: true,
                width: 80,
                align: 'center',
            },
            {
                name: '温度',
                th: true,
                width: 80,
                form: form,
                orderAttr: 'transportation_report_temperature',
                searchType: { name: 'temperature', type: 'number' },
                align: 'center',
            },
            {
                name: '備考',
                th: true,
                minWidth: 300,
            },
        ],
    }
}

export type TransportationReportTableDataProps = {
    transportationReport?: TransportationReport
    displaySetting: DisplaySetting
}

export const TransportationReportTableData = ({ transportationReport, displaySetting }: TransportationReportTableDataProps): JSX.Element => {
    if (!transportationReport) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new TransportationReportViewModel(transportationReport)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{transportationReport.id}</TableCell>
                <TableCell>{transportationReport.vendor?.name}</TableCell>
                <TableCell>{transportationReport.code}</TableCell>
                <TableCell>{vm.pickupDateText()}</TableCell>
                <TableCell>{vm.deliveryDateText()}</TableCell>
                <TableCell unit="枚" align="center">
                    {transportationReport.institutionsSheetCounts?.reduce((acc, cur) => acc + (cur.interviewSheetCount ?? 0), 0)}
                </TableCell>
                <TableCell unit="個" align="center">
                    {transportationReport.spitzCount}
                </TableCell>
                <TableCell align="center" unit="回">
                    {transportationReport.inspectionHistoryCount}
                </TableCell>
                <TableCell align="center" unit="℃">
                    {transportationReport.temperature}
                </TableCell>

                <TableCell>
                    <Flex alignItems="center">
                        <div style={{ flexGrow: 1 }}>
                            <ProgressBar variant="primary" now={vm.receiptRatio()} label={`${vm.receiptRatio()}%`}></ProgressBar>
                        </div>
                        <div style={{ fontSize: 10 }}>
                            {transportationReport.sampleSet?.length ?? 0} / {transportationReport.spitzCount}
                        </div>
                    </Flex>
                    <div style={{ marginTop: 5 }}>{transportationReport.note}</div>
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
